export default "__VITE_ASSET__Co0glqzH__"